export default {"src":"/_next/static/media/app-store.b8af77e3.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};